import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { ExerciseConfigurationPage } from './exercise-configuration-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [ExerciseConfigurationPage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class ExerciseConfigurationPageModule { }
